import { BaseService } from "../../baseService";
import { HmrcExchangeRateAPIService, HmrcExchangeRate } from "./hmrcExchangeRateAPIService";

class HmrcExchangeRateService extends BaseService<HmrcExchangeRateAPIService> {
  async getAllRates(): Promise<HmrcExchangeRate[]> {
    const response = await this.apiService.getHmrcExchangeRates();
    return response.items;
  }
}

export { HmrcExchangeRateService };
